import {
  addDeliveryCharge,
  changeDeliveryChargeStatus,
  deleteDeliveryCharge,
  getAllDeliveryCharge,
  getAllDoorstepDeliveryRequestAdmin,
  updateDeliveryCharge,
} from "services/deliverychargeService";

import {
  setCharges,
  setDeliveryRequests,
  setDeliveryRequestsPagination,
  setDeliveryChargeLoader,
  deliveryChargeSuccess,
  deliveryChargeError,
  setLastCreatedChargeId,
} from "./reducer";

export const fetchDeliveryCharges = () => async (dispatch: any) => {
  dispatch(setDeliveryChargeLoader(true));
  try {
    const res = await getAllDeliveryCharge();
    if (res?.success) {
      const arr = Array.isArray(res?.data) ? res.data : [];
      dispatch(setCharges(arr));
    } else {
      dispatch(
        deliveryChargeError({
          message: res?.message || "Failed to fetch delivery charges",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      deliveryChargeError({
        message: error?.message || "Error while fetching delivery charges",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setDeliveryChargeLoader(false));
  }
};

export const fetchDoorstepRequests =
  (filters: any) => async (dispatch: any) => {
    dispatch(setDeliveryChargeLoader(true));
    let res: any;
    try {
      res = await getAllDoorstepDeliveryRequestAdmin(filters);
      if (res?.success) {
        const payload = res?.data ?? {};
        const arr = Array.isArray(payload?.request)
          ? payload.request
          : Array.isArray(res?.data)
          ? res.data
          : [];
        const pagination =
          payload?.pagination ||
          res?.pagination ||
          res?.data?.pagination ||
          null;

        dispatch(setDeliveryRequests(arr));
        dispatch(setDeliveryRequestsPagination(pagination));
      } else {
        dispatch(
          deliveryChargeError({
            message: res?.message || "Failed to fetch requests",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      dispatch(
        deliveryChargeError({
          message: error?.message || "Error while fetching requests",
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setDeliveryChargeLoader(false));
    }
    return res;
  };

export const createDeliveryCharge = (data: any) => async (dispatch: any) => {
  dispatch(setDeliveryChargeLoader(true));
  try {
    const res = await addDeliveryCharge(data);
    if (res?.success) {
      dispatch(setLastCreatedChargeId(res?.data ?? null));
      dispatch(
        deliveryChargeSuccess({
          message: res?.message || "Charge created successfully",
          id: Date.now(),
        })
      );
      dispatch(fetchDeliveryCharges());
    } else {
      dispatch(setLastCreatedChargeId(null));
      dispatch(
        deliveryChargeError({
          message: res?.message || "Failed to create charge",
          id: Date.now(),
        })
      );
    }
    return res;
  } catch (error: any) {
    dispatch(
      deliveryChargeError({
        message: error?.message || "Error while creating charge",
        id: Date.now(),
      })
    );
    return { success: false, message: error?.message };
  } finally {
    dispatch(setDeliveryChargeLoader(false));
  }
};

export const editDeliveryCharge =
  (chargeId: number, data: any) => async (dispatch: any) => {
    dispatch(setDeliveryChargeLoader(true));
    try {
      const res = await updateDeliveryCharge(chargeId, data);
      if (res?.success) {
        dispatch(
          deliveryChargeSuccess({
            message: res?.message || "Charge updated successfully",
            id: Date.now(),
          })
        );
        dispatch(fetchDeliveryCharges());
      } else {
        dispatch(
          deliveryChargeError({
            message: res?.message || "Failed to update charge",
            id: Date.now(),
          })
        );
      }
      return res;
    } catch (error: any) {
      dispatch(
        deliveryChargeError({
          message: error?.message || "Error while updating charge",
          id: Date.now(),
        })
      );
      return { success: false, message: error?.message };
    } finally {
      dispatch(setDeliveryChargeLoader(false));
    }
  };

export const updateDeliveryChargeStatus =
  (chargeId: number, data: any) => async (dispatch: any) => {
    dispatch(setDeliveryChargeLoader(true));
    try {
      const res = await changeDeliveryChargeStatus(chargeId, data);
      if (res?.success) {
        dispatch(
          deliveryChargeSuccess({
            message: res?.message || "Charge status updated",
            id: Date.now(),
          })
        );
        dispatch(fetchDeliveryCharges());
      } else {
        dispatch(
          deliveryChargeError({
            message: res?.message || "Failed to update status",
            id: Date.now(),
          })
        );
      }
      return res;
    } catch (error: any) {
      dispatch(
        deliveryChargeError({
          message: error?.message || "Error while updating status",
          id: Date.now(),
        })
      );
      return { success: false, message: error?.message };
    } finally {
      dispatch(setDeliveryChargeLoader(false));
    }
  };

export const removeDeliveryCharge =
  (chargeId: number, data: any) => async (dispatch: any) => {
    dispatch(setDeliveryChargeLoader(true));
    try {
      const res = await deleteDeliveryCharge(chargeId, data);
      if (res?.success) {
        dispatch(
          deliveryChargeSuccess({
            message: res?.message || "Charge deleted successfully",
            id: Date.now(),
          })
        );
        dispatch(fetchDeliveryCharges());
      } else {
        dispatch(
          deliveryChargeError({
            message: res?.message || "Failed to delete charge",
            id: Date.now(),
          })
        );
      }
      return res;
    } catch (error: any) {
      dispatch(
        deliveryChargeError({
          message: error?.message || "Error while deleting charge",
          id: Date.now(),
        })
      );
      return { success: false, message: error?.message };
    } finally {
      dispatch(setDeliveryChargeLoader(false));
    }
  };

